import React from "react";

function BinIcon({
  width = "105",
  height = "105",
  showOuterCircle = true,
  showInnerCircle = true,
  iconFill = "#F44336",
  outerCircleFill = "#FFEBEE",
  innerCircleFill = "#FFDEDE",
}) {
  const showBackground = showOuterCircle || showInnerCircle;

  return (
    <svg
      width={width}
      height={height}
      viewBox={showBackground ? "0 0 105 105" : "32 31 41 44"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      style={{ display: "block" }}
    >
      {showOuterCircle && (
        <circle cx="52.5" cy="52.5" r="52.5" fill={outerCircleFill} />
      )}

      {showInnerCircle && (
        <circle cx="52.5" cy="52.5" r="37.5" fill={innerCircleFill} />
      )}

      <path
        d="M48.2404 37.9602V38.7335H55.9739V37.9602C55.9739 36.9346 55.5665 35.9511 54.8414 35.226C54.1162 34.5008 53.1327 34.0934 52.1071 34.0934C51.0816 34.0934 50.0981 34.5008 49.3729 35.226C48.6478 35.9511 48.2404 36.9346 48.2404 37.9602ZM45.147 38.7335V37.9602C45.147 36.1142 45.8803 34.3439 47.1856 33.0386C48.4908 31.7333 50.2612 31 52.1071 31C53.9531 31 55.7234 31.7333 57.0287 33.0386C58.334 34.3439 59.0673 36.1142 59.0673 37.9602V38.7335H70.6676C71.0778 38.7335 71.4712 38.8965 71.7613 39.1865C72.0513 39.4766 72.2143 39.87 72.2143 40.2802C72.2143 40.6904 72.0513 41.0838 71.7613 41.3739C71.4712 41.664 71.0778 41.8269 70.6676 41.8269H68.3352L65.4088 67.4527C65.193 69.34 64.2902 71.0818 62.8724 72.3461C61.4547 73.6103 59.6212 74.3086 57.7217 74.3077H46.4926C44.593 74.3086 42.7596 73.6103 41.3419 72.3461C39.9241 71.0818 39.0213 69.34 38.8055 67.4527L35.8791 41.8269H33.5467C33.1365 41.8269 32.7431 41.664 32.453 41.3739C32.163 41.0838 32 40.6904 32 40.2802C32 39.87 32.163 39.4766 32.453 39.1865C32.7431 38.8965 33.1365 38.7335 33.5467 38.7335H45.147ZM41.8803 67.1001C42.0095 68.2321 42.5506 69.2771 43.4006 70.0358C44.2506 70.7946 45.3501 71.214 46.4895 71.2143H57.7232C58.8626 71.214 59.9621 70.7946 60.8121 70.0358C61.6621 69.2771 62.2033 68.2321 62.3324 67.1001L65.2232 41.8269H38.9926L41.8803 67.1001ZM47.467 47.2404C47.8772 47.2404 48.2707 47.4033 48.5607 47.6934C48.8508 47.9835 49.0137 48.3769 49.0137 48.7871V64.2541C49.0137 64.6643 48.8508 65.0577 48.5607 65.3478C48.2707 65.6379 47.8772 65.8008 47.467 65.8008C47.0568 65.8008 46.6634 65.6379 46.3733 65.3478C46.0833 65.0577 45.9203 64.6643 45.9203 64.2541V48.7871C45.9203 48.3769 46.0833 47.9835 46.3733 47.6934C46.6634 47.4033 47.0568 47.2404 47.467 47.2404ZM58.294 48.7871C58.294 48.3769 58.131 47.9835 57.8409 47.6934C57.5509 47.4033 57.1575 47.2404 56.7473 47.2404C56.337 47.2404 55.9436 47.4033 55.6536 47.6934C55.3635 47.9835 55.2006 48.3769 55.2006 48.7871V64.2541C55.2006 64.6643 55.3635 65.0577 55.6536 65.3478C55.9436 65.6379 56.337 65.8008 56.7473 65.8008C57.1575 65.8008 57.5509 65.6379 57.8409 65.3478C58.131 65.0577 58.294 64.6643 58.294 64.2541V48.7871Z"
        fill={iconFill}
      />
    </svg>
  );
}

export default BinIcon;
